import fileSys from "../fileoprators/fileSystem";
import { objectCopy } from "../shared/utils";
import SettingsOprator from "./settingsoprator";
const DEFAULTSET = {
  enable: false,
  interval: 5000,
  worklist: {
    serverip: "127.0.0.1",
    serverport: "3000",
    aetitle: "OFFIS",
    localae: "",
    modality: "YD",
    worklistcharset: "utf8",
    stardate: "",
    enddate: ""
  },
  pdf: {
    serverip: "127.0.0.1",
    serverport: "3000",
    aetitle: "OFFIS",
    localae: "",
    modality: "YD",
    worklistcharset: "utf8"
  }
};
class Dicom extends SettingsOprator {
  constructor() {
    super(fileSys.getCfgPath("dicomSettings.json"), DEFAULTSET);
  }
  getDicomSettings() {
    return this.getSettings();
  }
  saveDicomSettings(settings) {
    this.saveSettings(settings);
  }
  restore() {
    window.dicomSettings = objectCopy(DEFAULTSET);
    this.saveSettings(window.dicomSettings);
  }
}
export default Dicom;



// WEBPACK FOOTER //
// ./src/settings/dicom.js